import Vue from 'vue'
import './js/lib/Materialize'
import './scss/main.scss'
import RootView from './templates/RootView.vue'
import router from './js/router'
import 'chartjs-plugin-annotation'


Vue.config.productionTip = true;

/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(RootView)
}).$mount('#app');
